<template>
  <div>
    <div 
      id="dropdown" 
      v-if="isDropdownVisible" 
      class="z-50 bg-white absolute right-0 top-16 rounded-lg shadow w-4/6 ">
      <div class="flex justify-between items-center p-2 px-3 w-full">
        <div>
          <h5 class="text-gray-500 font-light text-base mt-2">Filter</h5>
        </div>
        <div>
          <span class="cursor-pointer" @click="handleClose"><i class="fa-solid fa-xmark text-gray-500"></i></span>
        </div>
      </div>
      <div class="w-full mt-2 mb-3">
        <label class="mx-4 mb-2">Publisher</label>
        <MultiSelectFilter 
          v-if="this.userData.role_id === 5"
          :options="vendorSearchOptions"
          :loading="isVendorSearch"
          v-model="vendor"
          @search-change="vendorFind"
          :disabled="true"
        />
         <MultiSelectFilter 
         v-else
          :options="vendorSearchOptions"
          :loading="isVendorSearch"
          v-model="vendor"
          @search-change="vendorFind"
        />

      </div>
      <div class="w-full grid grid-cols-2 gap-3 justify-between px-4 ">
        <div class="w-full">
          <label class=" mb-2">Content Status </label>
          <div v-if="isBook">
          <StatusFilterComponentMultiple 
            v-model="status"
            :options="statusOptions"
          />
          </div>
          <div v-else>
             <StatusFilterComponent 
            v-model="status"
            :options="statusOptions"
          />
          </div>
        
        </div>
        <div class="w-full">
          <label class=" mb-2">Content Type</label>
          <ContentTypeSelector 
            v-model="contentType" 
            :options="contentTypeOptions" 
          />
        </div>
      </div>
     
      <div class="w-full flex justify-start px-4 mt-3 mb-3">
        <Button 
        variant="default"
        size="sm"
        class="mr-2"
        color="primary"
          @click="applyFilter">
          Filter
        </Button>
        <Button 
          variant="outlined"
        size="sm"
        class="ml-2"
        color="alternative"
          @click="resetFilter">
          Reset
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import ContentTypeSelector from '../../components/form/ContentTypeSelector.vue';
import StatusFilterComponent from '../../components/form/StatusFilterComponent.vue';
import MultiSelectFilter from '../../components/form/MultiSelectFilter.vue';
import { mapActions ,mapState } from 'vuex';
import constant from '../../store/constant';
import Button from '@/components/ui/Button';

import StatusFilterComponentMultiple from '../../components/form/StatusFilterComponentMultiple.vue';
const ITEM_STATUS = Object.entries(constant.ITEM_STATUS).map((item) => ({
  text: item[0],
  value: item[1]
}));

const ITEM_CONTENT_TYPE = Object.entries(constant.ITEM_CONTENT_TYPE).map((item) => ({
  text: item[0],
  value: item[1]
}));

export default {
  components: {
    ContentTypeSelector,
    MultiSelectFilter,
    StatusFilterComponentMultiple,
    StatusFilterComponent,
    Button
  },
 props: {
  isDropdownVisible: {
    type: Boolean,
    required: true
  },
  statusProp: {        // ini dari parent
    type: Array,
    default: () => []
  },
  vendorProp: {
    type: [Array, Object],
    default: () => []
  }
},
  data() {
    return {
      contentType: null,
      userData: JSON.parse(localStorage.getItem('session_auth')),
      status: [],
      vendor: [],
      isBook:'',
      isVendorSearch: false,
      vendorSearchOptions: [],
      statusOptions: [...ITEM_STATUS],
      contentTypeOptions: [...ITEM_CONTENT_TYPE],
    };
  },
  computed: {
  ...mapState({
    ebooks: state => state.ebooks.items
  }),
},
  watch: {
    isDropdownVisible(newVal) {
      if (newVal) {
        this.addOutsideClickListener();
      } else {
        this.removeOutsideClickListener();
      }
    },
     ebooks(newVal) {
      this.isBook = [...new Set(newVal.map(e => e.item_type))]
  },
     statusProp: {
    immediate: true,
    handler(newVal) {
      this.status = [...newVal];
    }
  },
    vendorProp: {
    immediate: true,
    handler(newVal) {
      this.vendor = [...newVal]; 
    }
  }
  },
  created() {
    this.publisherFind()
  },
  methods: {
    ...mapActions('vendors', ['searchVendors']),
    ...mapActions('ebooks', ['fetchEbooks']),
    applyFilter() {
      this.$emit('input', { contentType: this.contentType, status: this.status, vendor: this.vendor });
      this.$emit('reloadPage');
      
      this.handleClose(); 
    },
     async publisherFind() {
      if (this.userData.role_id === 5) {
        try {
          const response = await this.searchVendors({ email: this.userData.email });
          this.vendorSearchOptions = response.data.data.rows;
          this.vendor = this.vendorSearchOptions
        } catch (error) {
          console.error('Error fetching publisher data:', error);
        }
      }
    },
   resetFilter() {
  this.contentType = null;
  this.status = [];
  this.vendor = [];

  this.$emit('input', {
    contentType: null,
    status: [],
    vendor: []
  });

  this.$emit('input', { contentType: this.contentType, status: this.status, vendor: this.vendor });
  this.$emit('reloadPage');  
  this.$emit('reset'); 
},
    
    vendorFind(query) {
      if (!query) return;

      this.isVendorSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let payload = {
          name: query,
          limit: 10,
        };
        this.searchVendors(payload)
          .then((response) => {
            this.vendorSearchOptions = response.data.data.rows;
            this.isVendorSearch = false;
          })
          .catch(() => {
            this.isVendorSearch = false;
          });
      }, 600);
    },
    
    addOutsideClickListener() {
      setTimeout(() => { 
        document.addEventListener('click', this.handleOutsideClick);
      }, 0);
    },
    
    removeOutsideClickListener() {
      document.removeEventListener('click', this.handleOutsideClick);
    },
    
    handleOutsideClick(event) {
      if (!this.$el.contains(event.target)) {
        this.$emit('update:isDropdownVisible', false);
      }
    },
    
    handleClose() {
      this.$emit('update:isDropdownVisible', false);
    }
  },
  
  beforeDestroy() {
    this.removeOutsideClickListener();
  }
}
</script>
